import LABEL from '../../business-const/Label/Label'

import {
    pesquisaList,
    pesquisaDescricaoList,
} from '../../business-rules/List/ListService'

import perfilList from '../../business-rules/List/perfilList'



export const equipeListSelecao = ( id, equipeList, values, equipe, jsonConfiguracao, gestorLider ) => {

    let equipeListSelecaoAux = []

    equipeList?.forEach( (linhaEquipeList, index) => {
        
        if (
                (   
                    !values ||
                    values.equipeForm.email !== linhaEquipeList.email
                ) &&
                (
                    linhaEquipeList.id === id ||
                    (
                        (
                            !pesquisaList(equipe, linhaEquipeList.id).id &&
                            !gestorLider
                        ) ||
                        (
                            gestorLider &&
                            pesquisaList(perfilList, linhaEquipeList.perfil).gestorLider === 'S'
                        )
                    )
                )
        ) {
            equipeListSelecaoAux.push(
                {
                    id: linhaEquipeList.id,
                    descricao: linhaEquipeList.identificacao +
                        //(
                        //    linhaEquipeList.jsonUsuario &&
                        //        linhaEquipeList.jsonUsuario.nome
                        //            ?
                        //                linhaEquipeList.jsonUsuario.nome
                        //            :
                        //                linhaEquipeList.email
                        //) +
                        (
                            LABEL.traco + pesquisaDescricaoList(perfilList, linhaEquipeList.perfil) +
                            (linhaEquipeList.filialUnidade
                                ?
                                    LABEL.traco + pesquisaDescricaoList(jsonConfiguracao.filiaisUnidades, linhaEquipeList.filialUnidade)
                                : 
                                    ''
                            )
                        ),
                    ordem:
                        linhaEquipeList.jsonUsuario &&
                            linhaEquipeList.jsonUsuario.nome
                                ?
                                    linhaEquipeList.jsonUsuario.nome
                                :
                                    linhaEquipeList.email,
                }
            )
        }
    })

    return equipeListSelecaoAux
}